import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToNextSection = () => {
    const section = document.getElementById('estrutura-metodo');
    if (section) {
      section.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative pt-8 pb-3 md:pt-12 md:pb-4 overflow-hidden bg-gradient-to-br from-[#FFFDFB] via-[#FFFCF8] to-[#FFFDFB]" data-id="element-182">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-183">
        {/* Logo */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="flex justify-center mb-4 md:mb-6" data-id="element-184">
          <img src="https://cdn.magicpatterns.com/uploads/kKrA89B99SiXCMdmnxNubA/Logo_Efeito_Boutique_2.png" alt="Efeito Boutique" className="h-12 md:h-16 w-auto" data-id="element-185" />
        </motion.div>

        <div className="flex flex-col items-center text-center max-w-4xl mx-auto mb-4 md:mb-6" data-id="element-186">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="font-bold text-stone-900 tracking-tight leading-[1.1] mb-4 md:mb-6" data-id="element-187">
            <span className="block text-2xl md:text-4xl lg:text-5xl" data-id="element-188">
              Você cria com dedicação, mas sente que ninguém paga o justo pelo
              seu trabalho?
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-sm md:text-base text-stone-600 max-w-2xl leading-relaxed mb-6" data-id="element-189">
            O Efeito Boutique™ é o método que transforma qualquer lembrancinha
            simples em produto de boutique — para você cobrar o que merece.
            Chega de dar desconto!
          </motion.p>

          {/* Comparison Cards */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="w-full max-w-[320px] mx-auto mb-6" data-id="element-190">
            <div className="grid grid-cols-2 gap-3" data-id="element-191">
              {/* Card 1 - Cliente pede desconto */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5,
              delay: 0.35
            }} className="bg-white p-2.5 md:p-3 rounded-xl shadow-sm border border-stone-200" data-id="element-192">
                <div className="aspect-square rounded-lg bg-stone-100 mb-2 overflow-hidden relative" data-id="element-193">
                  <img src="https://cdn.magicpatterns.com/uploads/nd4YfbKYrUWWZYncJfkNAA/WhatsApp_Image_2026-01-14_at_17.02.23.jpg" alt="Produto comum" className="w-full h-full object-cover opacity-90" data-id="element-194" />
                  <div className="absolute top-1.5 left-1.5 bg-stone-900/70 backdrop-blur-sm text-white text-[10px] md:text-xs font-bold px-2 py-0.5 md:px-2.5 md:py-1 rounded-full leading-tight" data-id="element-195">
                    Cliente pede desconto
                  </div>
                </div>
                <p className="text-center font-medium text-stone-500 text-xs md:text-sm" data-id="element-196">
                  Produto Comum
                </p>
                <p className="text-center font-bold text-stone-700 text-sm md:text-base mt-0.5" data-id="element-197">
                  R$ 3,50
                </p>
              </motion.div>

              {/* Card 2 - Agenda lotada */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5,
              delay: 0.45
            }} className="bg-white p-2.5 md:p-3 rounded-xl shadow-lg border-2 border-brand-200" data-id="element-198">
                <div className="aspect-square rounded-lg bg-stone-100 mb-2 overflow-hidden relative" data-id="element-199">
                  <img src="https://cdn.magicpatterns.com/uploads/nab8vwQuF6nSxdNUDqy54X/PHOTO-2026-01-23-21-54-31.jpg" alt="Produto com Efeito Boutique" className="w-full h-full object-cover" data-id="element-200" />
                  <div className="absolute top-1.5 left-1.5 bg-brand-500 text-white text-[10px] md:text-xs font-bold px-2 py-0.5 md:px-2.5 md:py-1 rounded-full shadow-md leading-tight" data-id="element-201">
                    Agenda lotada
                  </div>
                </div>
                <p className="text-center font-bold text-brand-600 text-xs md:text-sm" data-id="element-202">
                  Produto com Efeito Boutique™
                </p>
                <p className="text-center font-bold text-brand-700 text-sm md:text-base mt-0.5" data-id="element-203">
                  R$ 9,00
                </p>
              </motion.div>
            </div>
          </motion.div>

          <p className="text-xs md:text-sm text-stone-400 mt-4 font-medium tracking-wide uppercase" data-id="element-204">
            Acesso imediato • Aplicação prática • Valor acessível
          </p>

          {/* Animated scroll arrow */}
          <motion.div className="mt-4 cursor-pointer" onClick={() => {
          const next = document.getElementById('empathy-section');
          if (next) {
            next.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1,
          duration: 0.6
        }} data-id="element-205">
            <motion.div animate={{
            y: [0, 8, 0]
          }} transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-206">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-brand-400 mx-auto" data-id="element-207">
                <path d="M7 13l5 5 5-5" data-id="element-208" />
                <path d="M7 6l5 5 5-5" data-id="element-209" />
              </svg>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}